/* eslint-disable no-restricted-imports */
import { Injectable } from '@angular/core';
import {
  PersonalDetails,
  PlayerDetails,
  UpdatePersonalDetailsModel,
  UpdatePlayerDetailsModel,
} from '@app/profile/models';
import { HttpService } from '@core/services';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private http: HttpService) {}

  getPersonalDetails(): Observable<PersonalDetails> {
    return this.http.get('/public/Profile');
  }

  updatePersonalDetails(payload: UpdatePersonalDetailsModel): Observable<PersonalDetails> {
    return this.http.put('/public/Profile', payload);
  }

  getPlayerDetails(): Observable<PlayerDetails> {
    return this.http.get('/public/Profile/player');
  }

  updatePlayerDetails(payload: UpdatePlayerDetailsModel): Observable<PlayerDetails> {
    return this.http.put('/public/Profile/player', payload);
  }

  getProfilePicture(): Observable<string> {
    return this.http.getBlob('/public/Profile/media/picture').pipe(map((blob) => window.URL.createObjectURL(blob)));
  }
}
